





import { Component, Vue, Prop } from 'vue-property-decorator';
import PlaidButton from '@/componentsV2/organisms/PlaidButton/PlaidButton.vue';

@Component({
  components: {
    PlaidButton
  }
})
export default class TestPlaidConnection extends Vue {}
